exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer-Footer-root{background:#005d82;color:#fff;position:fixed;left:0;bottom:0;width:100%;z-index:1005}.Footer-Footer-spirotech{background-color:#fae03a;color:#000}.Footer-Footer-container{margin:0 auto;padding:10px 15px;max-width:1200px;text-align:center}.Footer-Footer-text{color:hsla(0,0%,100%,.5)}.Footer-Footer-spacer{color:hsla(0,0%,100%,.3)}.Footer-Footer-link,.Footer-Footer-text{padding:2px 5px;font-size:1em}.Footer-Footer-link,.Footer-Footer-link:active,.Footer-Footer-link:visited{color:hsla(0,0%,100%,.6);text-decoration:none}.Footer-Footer-link:hover{color:#fff}.Footer-Footer-link_spirotech{color:#000!important}", ""]);

// exports
exports.locals = {
	"root": "Footer-Footer-root",
	"spirotech": "Footer-Footer-spirotech",
	"container": "Footer-Footer-container",
	"text": "Footer-Footer-text",
	"spacer": "Footer-Footer-spacer",
	"link": "Footer-Footer-link",
	"link_spirotech": "Footer-Footer-link_spirotech"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/Footer/Footer.css
// module id = 1116
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20